import { writable } from 'svelte/store';
/** Session flag shared by auth and modal routes without pulling Apollo into SSR graphs. */
export const loggedIn = writable(undefined);
